import type { ColScaffold } from "../../scaffold";
import { ArsListingColumn, EMPTY_HEADER_COL_ID, type ArsTextAlignment } from "./interface";

interface ColScaffoldWithAlignment<T> extends ColScaffold<T> {
  headerTextAlignment?: ArsTextAlignment;
  bodyTextAlignment?: ArsTextAlignment;
}

/**
 * Builds scaffold columns for the current listing state.
 *
 * @param selectedColumns - Selected listing columns
 * @param persistedWidths - Map of column ids to their persisted widths
 * @returns Scaffold column definitions with text alignment properties
 */
export const buildScaffoldColumns = <T>(
  selectedColumns: ArsListingColumn<T>[],
  persistedWidths?: Record<string, number>,
): ColScaffoldWithAlignment<T>[] => {
  const widths = persistedWidths ?? {};

  if (selectedColumns.length === 0) {
    const emptyCol: ColScaffoldWithAlignment<T> = {
      id: EMPTY_HEADER_COL_ID,
      colNumber: 1,
      noResize: true,
      width: 280,
    };
    return [emptyCol];
  }

  return selectedColumns.map((column, ix) => ({
    id: column.id,
    colNumber: ix + 1,
    width: widths[column.id] ?? column.columnWidth,
    headerTextAlignment: column.headerTextAlignment,
    bodyTextAlignment: column.bodyTextAlignment,
  }));
};
